import React, {Component} from "react";
import {Form, Select, Radio,Alert} from 'antd';
import NHFormItem from '../../../common/NHFormItem';
import NHFetch from "../../../../utils/NHFetch";
import NHMultiSelect from "../../../common/NHMultiSelect";
import PropTypes from "prop-types";
import StudentMng from "./index";

const RadioGroup = Radio.Group;
const Option = Select.Option;
const FormItem = Form.Item;

const basicUrl = '/lcpz/';

/**
 * 设置流程应用范围
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-12 15:25:12
 * Version: 1.0
 * Modify log:
 */
class ChooseRangeForm extends React.Component {

    static defaultProps={
        studentNumber:0,
    }

    constructor(props) {
        super(props);
        this.state = {
            qxxs: false, //是否选择全校新生
            xyxxData: [], //学院下拉数据
            zyxxData: [], //专业下拉数据
            bjxxData: [] //班级下拉数据
        }
    }

    //加载数据
    componentDidMount() {
        NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', {tag: 'xy', filter: ''})
            .then(res => {
                if (res) {
                    this.setState({xyxxData: res.data ? res.data : []});
                }
            })
    }

    //是否选择全校学生
    onRadioChange = (e) => {
        this.setState({qxxs: e.target.value});
    }

    //部门信息选择回调
    handleXyxxChange = (value) => {
        const {getFieldValue, setFieldsValue} = this.props.form;
        if (value && value.length > 0) {

            NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', {tag: 'zy', filter: value.toString()})
                .then(res => {
                    if (res) {
                        let zyids = getFieldValue('zyid');
                        if (zyids && res.data && zyids.length > 0 ){
                            let newData = res.data.map(item => item.VALUE);
                            newData = new Set(newData);
                            let newZyids = zyids.filter(item => newData.has(item));
                            setFieldsValue({zyid:newZyids});
                            this.handleZyxxChange(newZyids);
                        }
                        this.setState({zyxxData: res.data ? res.data : []});
                    }
                })

        } else {
            const {setFieldsValue} = this.props.form;
            setFieldsValue({zyid:[], bjid:[]});
            this.setState({zyxxData:[], bjxxData:[]});
        }

    }

    //专业信息选择回调
    handleZyxxChange = (value) => {
        const {getFieldValue, setFieldsValue} = this.props.form;
        if (value && value.length > 0) {

            NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', {tag: 'bj', filter: value.toString()})
                .then(res => {
                    if (res) {
                        let bjids = getFieldValue('bjid');
                        if (bjids && res.data && bjids.length > 0 ){
                            let newData = res.data.map(item => item.VALUE);
                            newData = new Set(newData);
                            let newBjids = bjids.filter(item => newData.has(item));
                            setFieldsValue({bjid:newBjids});
                        }
                        this.setState({bjxxData: res.data ? res.data : []});
                    }
                })

        } else {
            setFieldsValue({bjid:[]});
            this.setState({bjxxData:[]});
        }
    }

    render() {

        const formItemLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 12, offset: 6 },
                md: { span: 10, offset: 7 }
            }
        };

        const {form} = this.props;
        const {qxxs, xyxxData, zyxxData, bjxxData} = this.state;

        const {studentNumber} = this.props;
        let title = "本次添加涉及学生人数"+studentNumber+"人";

        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'qxxs'} label={'全校新生'} form={form} initialValue={false}>
                        <RadioGroup onChange={this.onRadioChange}>
                            <Radio value={true}>是</Radio>
                            <Radio value={false}>否</Radio>
                        </RadioGroup>
                    </NHFormItem>
                    <NHFormItem id={'xslbm'} label={'学生类别'} form={form}>
                        <NHMultiSelect sign={'dmk_xtgl_xslbm'} disabled={qxxs}/>
                    </NHFormItem>
                    <NHFormItem id={'xyid'} label={'学院名称'} form={form}>
                        <NHMultiSelect dataSource={xyxxData} disabled={qxxs} onChange={this.handleXyxxChange}/>
                    </NHFormItem>
                    <NHFormItem id={'zyid'} label={'专业名称'} form={form}>
                        <NHMultiSelect dataSource={zyxxData} disabled={qxxs} onChange={this.handleZyxxChange}/>
                    </NHFormItem>
                    <NHFormItem id={'bjid'} label={'班级名称'} form={form}>
                        <NHMultiSelect dataSource={bjxxData} disabled={qxxs} onChange={this.handleBjxxChange}/>
                    </NHFormItem>
                    <FormItem {...formItemLayout}>
                        <Alert showIcon message={title} />
                    </FormItem>
                </Form>
            </div>
        );
    }
}

ChooseRangeForm.propTypes = {
    onChange: PropTypes.func ,//初始数据
    studentNumber:PropTypes.number,
}

const chooseRangeForm = Form.create({onValuesChange(props, values){props.onChange(values);}})(ChooseRangeForm);
export default chooseRangeForm;


// WEBPACK FOOTER //
// ./components/lcgl/lcpz/student-mng/choose-range-form.js